function DDUFooterBrakeBias({value}) {
    const formattedBias = (rawBias) => {
        const numericBias = parseFloat(rawBias);
        
        if (isNaN(numericBias) || rawBias <= 0) return "0.0";

        let val = parseFloat((Math.floor(numericBias * 10) / 10).toFixed(1));
        if ((val * 10) % 2 !== 0) {
            val += 0.1;
        }

        return (Math.floor(val * 10) / 10).toFixed(1);
    };

    return (
        <div class="relative flex items-center justify-center border-[#f93a3a] border-[2px] rounded-[10px] text-[#f93a3a]">
            <p class={`${value["pit-limiter"] === 1 ? "bg-[#0743c2]" : "bg-[#0a0f14]"} absolute top-[-13px] text-[12px] px-3 py-1 uppercase font-bold`}>BB</p>
            <h1 class="text-[32px] font-bold">{formattedBias((value["brake-bias"]*100))}</h1>
        </div>
    );
}

export default DDUFooterBrakeBias;